import { __assign } from "tslib";
import mergeRefs from 'react-merge-refs';
import React, { forwardRef, useCallback, useImperativeHandle, useMemo } from 'react';
import OptionsList from '../../internal/components/options-list';
import { renderOptions } from '../utils/render-options';
import { useVirtual } from 'react-virtual';
import { useContainerQuery } from '../../internal/hooks/container-queries';
import styles from './styles.css.js';
var VirtualList = function (_a, ref) {
    var menuProps = _a.menuProps, getOptionProps = _a.getOptionProps, filteredOptions = _a.filteredOptions, filteringValue = _a.filteringValue, isKeyboard = _a.isKeyboard, checkboxes = _a.checkboxes, hasDropdownStatus = _a.hasDropdownStatus, listBottom = _a.listBottom;
    // update component, when it gets wider or narrower to reposition items
    var _b = useContainerQuery(function (rect) { return rect.width; }, []), width = _b[0], menuRef = _b[1];
    var _c = useVirtual({
        size: filteredOptions.length,
        parentRef: menuRef,
        // estimateSize is a dependency of measurements memo. We update it to force full recalculation
        // when the height of any option could have changed:
        // 1: because the component got resized (width property got updated)
        // 2: becasue the option changed its content (filteringValue property controls the highlight and the visibility of hidden tags)
        // eslint-disable-next-line react-hooks/exhaustive-deps
        estimateSize: useCallback(function () { return 31; }, [width, filteringValue]),
        overscan: 5
    }), virtualItems = _c.virtualItems, totalSize = _c.totalSize, scrollToIndex = _c.scrollToIndex;
    useImperativeHandle(ref, function () { return function (index) {
        if (isKeyboard) {
            scrollToIndex(index);
        }
    }; }, [isKeyboard, scrollToIndex]);
    var filteredOptionsSlice = virtualItems.map(function (_a) {
        var index = _a.index;
        return filteredOptions[index];
    });
    var finalOptions = useMemo(function () {
        return renderOptions({
            options: filteredOptionsSlice,
            getOptionProps: getOptionProps,
            filteringValue: filteringValue,
            isKeyboard: isKeyboard,
            checkboxes: checkboxes,
            hasDropdownStatus: hasDropdownStatus,
            virtualItems: virtualItems
        });
    }, [filteredOptionsSlice, getOptionProps, filteringValue, isKeyboard, checkboxes, virtualItems, hasDropdownStatus]);
    return (React.createElement(OptionsList, __assign({}, menuProps, { ref: mergeRefs([menuRef, menuProps.ref]) }),
        React.createElement("div", { "aria-hidden": "true", key: "total-size", className: styles['layout-strut'], style: { height: totalSize } }),
        finalOptions,
        listBottom ? React.createElement("li", { className: styles['list-bottom'] }, listBottom) : null));
};
export default forwardRef(VirtualList);
//# sourceMappingURL=virtual-list.js.map